module.exports = __webpack_public_path__ + "static/img/color-style@w.a6e3b6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-chem-pr-portal/color-style@w.png
// module id = e6zx
// module chunks = 0